<template>
  <div>
    <b-container fluid class="px-2">
      <b-row class="">
        <b-col cols="12" md="3" class="">
          <h6 class="text-primary font-weight-bold mb-2">
            {{ id > 0 ? 'Изменить слайд' : 'Добавить слайд' }}
          </h6>
          <div class="card card-body">
            <!-- Menu Create Title -->
            <b-form-group
              label="Заголовок"
              label-for="titleSlider"
            >
              <b-form-input
                id="titleSlider"
                placeholder="Заголовок"
                v-model="title"
              />
            </b-form-group>

            <!-- Menu Create Title -->
            <b-form-group
              label="Короткое описание"
              label-for="descSlider"
            >
              <b-form-input
                id="descSlider"
                placeholder="Короткое описание"
                v-model="description"
              />
            </b-form-group>

            <b-form-group>
              <picture-input
                ref="pictureInput"
                @change="onChange"
                width="600"
                height="600"
                margin="10"
                accept="image/*"
                size="10"
                :zIndex="0"
                buttonClass="btn btn-outline-primary"
                removeButtonClass="btn m-0 btn-outline-danger"
                :prefill="previewPhoto ? previewPhoto : ''"
                :prefillOptions="{mediaType: 'image/*'}"
                :crop="false"
                removable
                :customStrings="{
                  upload: '<h1>Bummer!</h1>',
                  drag: 'Перетащите файл сюда...',
                  tap: 'Tap here to select a photo <br>from your gallery', // HTML allowed
                  change: 'Измени фотографию', // Text only
                  remove: 'Удалить фотографию', // Text only
                  select: 'Select a Photo', // Text only
                  selected: '<p>Photo successfully selected!</p>', // HTML allowed
                  fileSize: 'The file size exceeds the limit', // Text only
                  fileType: 'This file type is not supported.', // Text only
                  aspect: 'Landscape/Portrait', // Text only
              }">
              </picture-input>
            </b-form-group>
            <!-- In New Tab -->
            <b-form-group>
              <b-form-checkbox
                v-model="isDefault"
              >
                Сделать активным
              </b-form-checkbox>
            </b-form-group>

            <!-- Button -->
            <b-form-group v-if="id == 0" class="mt-1">

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-2 btn-block"
                @click="storeSlide"
              >
                Сохранить
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="light"
                @click="createSlide"
                class="mr-2 btn-block"
              >
                Очистить
              </b-button>

            </b-form-group>
            <b-form-group v-if="id > 0" class="mt-1">

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-2 btn-block"
                @click="updateSlide"
              >
                Обновить
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="light"
                @click="createSlide"
              >
                Отменить
              </b-button>

            </b-form-group>
          </div>
        </b-col>
        <b-col cols="12" md="9" class="">
          <h6 class="text-primary font-weight-bold mb-2">
            Список слайдов
          </h6>
          <div class="card card-body">
            <!-- draggable -->
            <draggable
              class="row"
            >
              <b-col cols="12" md="4" v-for="(value, index) in slides" :data="value" :key="index">
                <div class="position-relative rounded overflow-hidden">
                  <div
                    class="position-absolute w-100 h-100 p-2 text-white mb-2"
                    style="background: rgb(2,0,36); background: linear-gradient(180deg, rgba(2,0,36,1) 0%, rgba(0,212,255,0) 100%);"
                    v-show="value.seen"
                  >
                    <h4 class="text-white">{{ value.title }}</h4>
                    <p>
                      {{ value.description }}
                    </p>
                  </div>
                  <b-img class="mb-2 rounded" :src="value.photo" fluid
                         :alt="value.title"/>

                </div>
                <b-form-group class="d-flex justify-content-center">
                  <b-button-group>
                    <button
                      class="btn btn-outline-primary"
                      v-b-tooltip.hover.v-primary
                      :title="value.title"
                      v-on:click="value.seen = !value.seen"
                    >
                      <feather-icon
                        icon="FileTextIcon"
                        class="mr-50"
                      />
                    </button>
                    <button
                      class="btn btn-outline-primary"
                      v-b-tooltip.hover.v-primary
                      title="Редактировать"
                      @click="editSlide(value)"
                    >
                      <feather-icon
                        icon="EditIcon"
                        class="mr-50"
                      />

                    </button>
                    <button
                      class="btn btn-outline-danger"
                      v-b-tooltip.hover.v-danger
                      title="Удалить"
                      @click="destroySlide(value.id)"
                    >
                      <feather-icon
                        icon="XIcon"
                        class="mr-50"
                      />
                    </button>
                  </b-button-group>
                </b-form-group>
              </b-col>
            </draggable>
          </div>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
  BImg,
  BButtonGroup,
  VBTooltip,
} from 'bootstrap-vue'
import PictureInput from 'vue-picture-input'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import http from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    PictureInput,
    BImg,
    draggable,
    BButtonGroup,
  },
  data() {
    return {
      seen: false,
      url: '',
      slides: [],
      id: 0,
      title: '',
      description: '',
      isDefault: false,
      photo: null,
      previewPhoto: null,
    }
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  methods: {
    onChange(image) {
      if (image) {
        this.photo = image
      }
    },
    readSlides() {
      const that = this
      http.get('admin/slides',
        {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          that.slides = response.data
        }).catch()
    },
    createSlide() {
      this.id = 0
      this.title = ''
      this.description = ''
      this.isDefault = false
      this.previewPhoto = null
      this.photo = null
      this.$refs.pictureInput.removeImage()
    },
    storeSlide() {
      const that = this
      const formData = new FormData()

      formData.append('title', that.title)
      formData.append('description', that.description)
      formData.append('is_default', that.isDefault ? 1 : 0)
      if (that.photo) {
        formData.append('photo', that.photo)
      }
      http.post('admin/slides', formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          if (response.data === 1) {
            that.readSlides()
            that.createSlide()
          }
        })
    },
    editSlide(slide) {
      if (slide) {
        this.id = slide.id
        this.title = slide.title
        this.description = slide.description
        this.isDefault = slide.is_default
        this.previewPhoto = slide.photo
        this.photo = null
      }
    },
    updateSlide() {
      if (this.id > 0) {
        const that = this
        const formData = new FormData()
        formData.append('title', that.title)
        formData.append('description', that.description)
        formData.append('is_default', that.isDefault ? 1 : 0)
        formData.append('_method', 'PUT')
        if (that.photo) {
          formData.append('photo', that.photo)
        }
        http.post(`admin/slides/${that.id}`, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => {
            if (response.data === 1) {
              that.readSlides()
              that.createSlide()
            }
          })
      }
    },
    destroySlide(id) {
      const that = this
      http.post(`admin/slides/${id}`, {
        _method: 'DELETE',
      })
        .then(response => {
          if (response.data === 1) {
            that.readSlides()
            that.createSlide()
          }
        })
    },
  },
  created() {
    this.url = 'https://tojtel.tj'
    this.readSlides()
  },
}
</script>
